import * as Yup from "yup";
import {
  DATE_MAYOR_VALIDATION_ERROR,
  FIELD_REQUIRED_MESSAGE,
} from "../utils/validations";

export const personalInitialValues = {
  id: 0,
  profile_avatar: null,
  name: "",
  role: "",
  phone: "",
  email: "",
  address: "",
  country: "",
  state: "",
  city: "",
  branch_id: 1,
  gym_id: 1,
  postal_code: "",
  dni: "",
  occupation: "",
  occupation_description: "",
  company: "",
  birthday: null,
  is_chat_responsible: false,
  sex: "",
  objective: "",
  accept_clauses: true,
  sufficiently_informed: true,
  receive_communications: true,
  image_rights: true,
};

export const personalValidationSchema = Yup.object({
  profile_avatar: Yup.mixed().nullable(),

  gym_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),
  branch_id: Yup.number().required(FIELD_REQUIRED_MESSAGE),

  name: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  role: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  phone: Yup.string().optional(),
  email: Yup.string().email("Email inválido").required(FIELD_REQUIRED_MESSAGE),
  address: Yup.string().optional(),
  country: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  state: Yup.string().optional(),
  city: Yup.string().optional(),
  postal_code: Yup.string().optional(),
  dni: Yup.string().optional(),
  occupation: Yup.string().optional(),
  occupation_description: Yup.string().optional(),
  company: Yup.string().optional(),
  birthday: Yup.date()
    .required(FIELD_REQUIRED_MESSAGE)
    .max(new Date(), DATE_MAYOR_VALIDATION_ERROR),
  sex: Yup.string().required(FIELD_REQUIRED_MESSAGE),
  objective: Yup.string().optional(),
  accept_clauses: Yup.boolean().oneOf([true], "Debe aceptar las cláusulas"),
  sufficiently_informed: Yup.boolean().oneOf(
    [true],
    "Debe estar suficientemente informado"
  ),
  receive_communications: Yup.boolean().optional(),
  image_rights: Yup.boolean().optional(),
  is_chat_responsible: Yup.boolean().optional(),
});

export type UserValues = typeof personalInitialValues;
